import { useTranslation } from 'gatsby-plugin-react-i18next'
import React, { useState } from 'react';
import { registersSideMenuSearchEvent } from 'src/services/GoogleTagManager'
import { clearOpenSelection, setSearchQuery, useIsAlphabetical, useSearchQuery } from './side-menu-store'
import SearchIcon from '../../images/icons/search.svg'
import CloseIcon from '../../images/icons/Icon-Close.svg'
import styled from 'styled-components'
import tailwindConfig from 'src/../tailwind.config'
import resolveConfig from 'tailwindcss/resolveConfig'

const tailwind = resolveConfig(tailwindConfig);

const SearchImage = styled.div`
  background-color: #edf2f6;
  cursor: pointer;
  width: 30px;
  flex: none;
  margin-right: 10px;
`;

const Search = styled.input.attrs({ type: "text" })`
  height: 47px;
  width: 100%;
  background-size: 25px 25px;
  background-repeat: no-repeat;
  padding-right: 20px;
  padding-left: 15px;
  background-color: #edf2f6;
  font-weight: bold;
  outline: none;
  cursor: pointer;
  &::placeholder {
    font-weight: bold;
    color: #000;
  }
  &:focus {
    &::placeholder {
      color: transparent;
    }
    &::-webkit-input-placeholder {
      color: transparent;
    }
    &:-moz-placeholder {
      color: transparent;
    }
    &::-moz-placeholder {
      color: transparent;
    }
  }
  @media (min-width: 13.7rem) {
    -webkit-appearance: none;
    -webkit-border-radius: 0;
    border-radius: 0;
  }
  @media (min-width: ${tailwind.theme.screens.lg}) {
    -webkit-appearance: none;
    -webkit-border-radius: 0;
    border-radius: 0;
  }
`;

const SearchInput = () => {
  const { t } = useTranslation("menu");
  const searchQuery = useSearchQuery()
  const [search, setSearch] = useState<string>(searchQuery)
  const isAlphabetical = useIsAlphabetical()

  const showCloseIcon = !!searchQuery && (searchQuery === search || !search) 
  
  const handleSearch = () => {
    if (showCloseIcon) {
      if (!isAlphabetical) {
        clearOpenSelection()
      }
      setSearchQuery('')
      setSearch('')
    } else if (search) {
      registersSideMenuSearchEvent(search)
      setSearchQuery(search)
    }
  }

  return (
    <div className="flex bg-[#edf2f6] h-[47px] w-full">
      <div className="flex-[1_1_auto]">
        <Search
          placeholder={t('SEARCH')}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              handleSearch()
            }
          }}
          required
          value={search}
          onChange={(e) => {
            setSearch(e.target.value)
          }}
        />
      </div>
      
      <SearchImage>
        <img
          onClick={handleSearch}
          src={showCloseIcon ? CloseIcon : SearchIcon}
          className="w-full mt-2"
        />
      </SearchImage>
    </div>
  )
}

export default SearchInput
